module.exports = __webpack_public_path__ + "media/images/Group-38e65991c3ee8689e9052d51a5e33c4c.png";